<template>
  <div class="header_li_wrap">
    <div class="header_li_box">
      <div class="headcer_li_logo" style="margin: 0px;width: 35%;">
        <div class="logo" @click="goToIndex">
          <img src="./img/jrylogo.png" style="width: 100%;display: flex;justify-content: space-between;" />
        </div>
      </div>
      <div class="header_li_wrap_t">
        <div style="width: 100%;display:flex;justify-content: space-around;">
          <div :id="item.categoryOrder" v-for="item in listData" :key="item.code" class="header_li_right_item" style="margin-right: 10px;cursor:pointer" @click="pushRouter(item)">
            <div>{{item.categoryName}}</div>
            <div class="on" :style="activePageUrl == item.categoryOrder ? '' : 'visibility: hidden'">
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="header_li_right">
        <ul>
          <li :id="item.categoryOrder" v-for="item in listData" :key="item.code" class="header_li_right_item" :style="`cursor:pointer`" @click="pushRouter(item)">
            <p>{{item.categoryName == "新闻中心页" ? "新闻中心" : item.categoryName}}</p>
            <div class="on" :style="activePageUrl == item.categoryOrder ? '' : 'visibility: hidden'">
            </div>
          </li>
        </ul>
      </div> -->
      <!-- <div class="btn_top" @click="goToLogin()">
        <img src="@/static/common/tc.png" style="margin-right: 7px;" />
        登录
      </div> -->
      <div class="search_box">
        <div style="cursor: pointer;" @click.stop="block" id="icon">
          <el-icon :size="30" color="#fff">
            <Search />
          </el-icon>
        </div>
        <div style="display: none;" id="search">
          <div style="display: flex;">
            <el-input v-model="input" class="w-50 m-2" size="default" placeholder="搜索您想要招投标信息" ref="refInput" @click.stop="focus">
              <template v-slot:suffix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>
            <div class="search" @click.stop="Search">搜索</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import imgData from "@/data.js";
import { reactive, computed, ref, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import { mainStore } from "@/store";
import { storeToRefs } from "pinia";
import { queryNavigateList } from "@/api/index.js";
export default {
  setup() {
    const storeOfmain = mainStore();
    const store = mainStore();
    const activePageUrl = computed(() => {
      return storeToRefs(store).activePageUrl;
    });
    // const listData = computed(() => storeToRefs(store).navBar);
    const listData = ref([])
    const arr = async () => {
      let res = await queryNavigateList()
      listData.value = res.data
    }
    const router = useRouter();
    const input = ref('')
    const Search = () => {
      window.open(
        router.resolve({
          path: `/AllSearch`,
          query: { keyWord: input.value }
        }).href,
        "_blank"
      );
    }
    const goToIndex = () => {
      store.setactivePageUrl("/index");
      router.push({ path: "/index" });
    };
    const pushRouter = (item) => {
      console.log(item);
      const { categoryType, link } = item;
      if (item.categoryName == '法律法规') {
        storeOfmain.setData("news_ActiveType", "use");
        router.push({
          path: "/ListOfNews",
        });
        store.setData("news_ActiveId", item.id);
        store.newsReloadTableData();
        store.setactivePageUrl(item.categoryOrder);
      } else if (item.categoryName == '曝光台') {
        storeOfmain.setData("news_ActiveType", "help");
        router.push({
          path: "/ListOfNews1",
        });
        store.setData("news_ActiveId", item.id);
        store.newsReloadTableData();
        store.setactivePageUrl(item.categoryOrder);
      } else if (item.categoryName == '操作流程') {
        storeOfmain.setData("news_ActiveType", "policy");
        router.push({
          path: "/ListOfNews2",
        });
        store.setData("news_ActiveId", item.id);
        store.newsReloadTableData();
        store.setactivePageUrl(item.categoryOrder);
      } else if (item.categoryName == '办事指南') {
        storeOfmain.setData("news_ActiveType", "tool");
        router.push({
          path: "/ListOfNews",
        });
        store.setData("news_ActiveId", item.id);
        store.newsReloadTableData();
        store.setactivePageUrl(item.categoryOrder);
      } else if (categoryType == 2) {
        const path = link == "/" ? "/index" : link;
        router.push({ path });
        store.setactivePageUrl(item.categoryOrder);
      } else if (item.categoryType == 3) {
        window.open(link, "_blank");
      }
    };
    const refInput = ref()
    const block = () => {
      const search = document.querySelector('#search')
      search.style.display = 'block'
      const icon = document.querySelector('#icon')
      icon.style.display = 'none'
      nextTick(() => {
        console.log("进入")
        refInput.value.focus()
      })
    }
    const focus = () => {
      const search = document.querySelector('#search')
      search.style.display = 'block'
      const icon = document.querySelector('#icon')
      icon.style.display = 'none'
    }
    const blur = () => {
      const search = document.querySelector('#search')
      search.style.display = 'none'
      const icon = document.querySelector('#icon')
      icon.style.display = 'block'
    }
    onMounted(async () => {
      await arr()
    })
    const data = reactive({
      activePageUrl,
    });
    return {
      focus,
      refInput,
      block,
      blur,
      ...data,
      ...imgData,
      pushRouter,
      activePage: "/index",
      haveToken: false,
      goToIndex,
      listData,
      arr,
      Search,
      input
    };
  },
  created() {
    // this.activePageUrl = '/index'
    let href = window.location.href;
    let origin = window.location.origin + "/";
    this.activePage =
      href.replace(origin, "") == "BiddingInfo"
        ? ""
        : "/" + href.replace(origin, "");

    let arr = document.cookie.split(";");
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf("saber-access-token") !== -1) {
        this.haveToken = true;
      }
    }
  },
  methods: {
    goToLogin() {
      // console.log(process.env);
      window.open(process.env.VUE_APP_SEVERCE_PLATFORM, "_blank");
      // location.href = process.env.VUE_APP_SEVERCE_PLATFORM;
    },
    goToRegister() {
      window.open(process.env.VUE_APP_SEVERCE_REGISTER, "_blank");
      // location.href = process.env.VUE_APP_SEVERCE_REGISTER;
    },
  },
};
</script>

<style >
@import url("./Header.css");
.notShow {
  display: none;
}
.on {
  width: 55px;
  height: 4px;
  background: rgba(248, 195, 133, 1);
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
}
</style>